import { render, staticRenderFns } from "./Bouton.vue?vue&type=template&id=71a797c7"
import script from "./Bouton.vue?vue&type=script&lang=ts"
export * from "./Bouton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports